import React from 'react';
import { useServicesContext, useClientServerUtils } from '@oneaudi/vtp-shared';
import { TrackingServiceV2 } from '@oneaudi/audi-tracking-service';
import { trackFeatureAppReady } from '../../tracking/tilesTracking';
import { ContentService } from '@oneaudi/content-service';
import Favorites from './Favorites';
import Results from './Results';
import { SELECTORS } from '@oneaudi/stck-store';
import { useSelector } from 'react-redux';
import { TilesSkeleton } from './Skeleton/TilesSkeleton';

interface TilesWrapperProps {}
const TilesWrapper: React.FC<TilesWrapperProps> = () => {
  const servicesContext = useServicesContext();
  const isLoading = useSelector((state) => SELECTORS.UI.getLoadingState(state));
  const audiContentService = servicesContext.getAdditionalService(
    'audi-content-service'
  ) as ContentService;
  const content = audiContentService.getContent();
  const sortingOptions = content.fields?.vtpConfiguration?.fields.sortParams_options;
  const sortingDefaultOptions = content.fields?.vtpConfiguration?.fields.sortParams_defaultOption;

  const appContext: 'favorites' | 'results' = content.fields.appContext || 'results';

  const sortParam: string = sortingDefaultOptions || sortingOptions?.[0] || 'prices.retail:asc';

  const { isClient } = useClientServerUtils();

  const trackingService = useServicesContext().getAdditionalService(
    'audi-tracking-service'
  ) as TrackingServiceV2;
  React.useEffect(() => {
    trackFeatureAppReady(trackingService, sortParam);
  }, []);

  if (isLoading || !isClient) {
    // render skeleton when Loading or on SSR
    return <TilesSkeleton />;
  }

  return appContext === 'favorites' ? <Favorites /> : <Results />;
};

export default TilesWrapper;
